// extracted by mini-css-extract-plugin
module.exports = {"container":"EditRoom_container__2Q2iW"};